import { mixpanel } from '@fiverr-private/obs';
import { MIXPANEL_EVENT_PROPERTIES } from '../../constants';
import { Enrichment } from '../types';

type PackageTypeWithFreeVariation = 'premium' | 'unlimited';

export const createReportFreeVariation =
    (location: string, enrichment?: Enrichment) => (packageType: PackageTypeWithFreeVariation) => {
        mixpanel.track('Logo Maker - Get Free Variation', {
            [MIXPANEL_EVENT_PROPERTIES.PACKAGE_TYPE]: packageType,
            [MIXPANEL_EVENT_PROPERTIES.LOCATION]: location,
            ...enrichment,
        });
    };
